var React = require('react');

function MenuClose (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_36_1150)","key":0},React.createElement("path",{"d":"M20 21.3063L12.16 12.0057C16.16 7.23619 19.79 2.80054 19.89 2.58591C19.21 1.75124 18.52 0.940423 17.8 0.0819092L10 9.3944L2.18 0.0819092L1.09 1.36968L0.09 2.56206C0.37 3.00324 3.96 7.33158 7.84 11.9461L0 21.3063L1.08 22.606L2.08 23.7984C2.45 23.4645 6.08 19.1839 9.95 14.5455C13.95 19.315 17.67 23.6434 17.85 23.7626L20 21.3063Z","fill":"#091DF3"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_36_1150"},React.createElement("rect",{"width":"19.98","height":"23.7522","fill":"white","transform":"translate(0 0.0819092)"})))]);
}

MenuClose.defaultProps = {"width":"20","height":"24","viewBox":"0 0 20 24","fill":"none"};

module.exports = MenuClose;

MenuClose.default = MenuClose;
